// AUTO GENERATED FILE; DO NOT EDIT, see `gen-js-choices.py` and `make gen-js-choices`// TODO: auto generate labels.js too, and rename file, as this isn't just text-choices

// machine_data.constants.PipeDataStatusChoices
export const PipeDataStatusChoices = Object.freeze({
    PASSIVE: 0,
    IN_PRODUCTION: 1,
    CANCELED: 2,
    COMPLETED: 3,
});

// machine_data.web_socket.MachineDataWebSocketAction
export const MachineDataWebSocketAction = Object.freeze({
    pipe_data_received: 'pipe_data_received',
    change_auto_filters: 'change_auto_filters',
    machine_mode_change: 'machine_mode_change',
    mandrel_change: 'mandrel_change',
    ask_production_completed: 'ask_production_completed',
    close_confirmation_modal: 'close_confirmation_modal',
    refresh_products: 'refresh_products',
});

// machine_data.constants.MachineOperationModes
export const MachineOperationModes = Object.freeze({
    INACTIVE: 'inactive',
    AUTO: 'auto',
    MANUAL: 'manual',
    SCRAP: 'scrap',
});

// machine_data.constants.PipeDataStatisticAggregationsKeys
export const PipeDataStatisticAggregationsKeys = Object.freeze({
    sum__Extruder_1__MainComponent: 'sum__Extruder_1__MainComponent',
    sum__Extruder_2__MainComponent: 'sum__Extruder_2__MainComponent',
    sum__Extruder_1__AddComponent_1: 'sum__Extruder_1__AddComponent_1',
    sum__Extruder_2__AddComponent_1: 'sum__Extruder_2__AddComponent_1',
    sum__CoExtruder__MainComponent: 'sum__CoExtruder__MainComponent',
    sum__CoExtruder__AddComponent_1: 'sum__CoExtruder__AddComponent_1',
    sum__CoreTube_used_meters: 'sum__CoreTube_used_meters',
    sum__Gas_Used: 'sum__Gas_Used',
    sum__Energy_Used: 'sum__Energy_Used',
    sum__Max_Extruder_Time: 'sum__Max_Extruder_Time',
    main_material: 'main_material',
    material_reuse: 'material_reuse',
    natural_material: 'natural_material',
    masterbatch: 'masterbatch',
    total_material_used: 'total_material_used',
});

// qualityassurance.constants.QrsPipeStatuses
export const QrsPipeStatuses = Object.freeze({
    STATUS_NONE: 0,
    STATUS_OK: 1,
    STATUS_FAULTY: 2,
    STATUS_REUSE: 3,
    STATUS_REVIEW: 4,
    STATUS_COOLING: 5,
});

// qualityassurance.constants.PipeInternalColors
export const PipeInternalColors = Object.freeze({
    YELLOW: 0,
    BLACK: 1,
    ECO: 2,
    GRAY: 3,
    ANTISTATIC: 4,
    BLUE: 5,
    GREEN: 6,
});

// odoo.constants.BillOfMaterialComponentSourceChoices
export const BillOfMaterialComponentSourceChoices = Object.freeze({
    Extruder_1__MainComponent: 'Extruder_1__MainComponent',
    Extruder_2__MainComponent: 'Extruder_2__MainComponent',
    Extruder_1__AddComponent_1: 'Extruder_1__AddComponent_1',
    Extruder_2__AddComponent_1: 'Extruder_2__AddComponent_1',
    CoExtruder__MainComponent: 'CoExtruder__MainComponent',
    CoExtruder__AddComponent_1: 'CoExtruder__AddComponent_1',
    CoreTube__Feeder: 'CoreTube__Feeder',
});

// odoo.constants.QuantityUnitChoices
export const QuantityUnitChoices = Object.freeze({
    meters: 'm',
    kilogram: 'kg',
    pieces: 'pcs',
});

// odoo.constants.OdooConfirmTypes
export const OdooConfirmTypes = Object.freeze({
    UNCONFIRMED: 'unconfirmed',
    MANUAL: 'manual',
    AUTO: 'auto',
});

// orders.constants.PartProductProductionStatus
export const PartProductProductionStatus = Object.freeze({
    UNPLANNED: 0,
    PARTIALLY_PLANNED: 1,
    PLANNED: 2,
    COMPLETED: 3,
});

// orders.constants.PipeProductProductionStatus
export const PipeProductProductionStatus = Object.freeze({
    NEW: 0,
    IN_PROGRESS: 1,
    COMPLETED: 2,
    PAUSED: 3,
});

// orders.constants.OrderStatus
export const OrderStatus = Object.freeze({
    NEW: 0,
    PLANNED: 1,
    COMPLETED: 2,
    DEACTIVATED: 3,
});

// orders.constants.OrderType
export const OrderType = Object.freeze({
    DIRECTO: 'DIRECTO',
    ODOO: 'ODOO',
});

// orders.constants.PartOrderStatus
export const PartOrderStatus = Object.freeze({
    UNPLANNED: 4,
    PARTIALLY_PLANNED: 5,
    PLANNED: 6,
    PARTIALLY_COMPLETED: 7,
    COMPLETED: 8,
    DEACTIVATED: 3,
});

// orders.constants.PipeProductPlanTypes
export const PipeProductPlanTypes = Object.freeze({
    PPRC: 1,
    PERC: 2,
});

// workplan.constants.WorkOrderStatus
export const WorkOrderStatus = Object.freeze({
    NOT_STARTED: 0,
    RUNNING: 1,
    PAUSED: 2,
    DONE: 3,
    DOWNTIME: 4,
});

// workplan.constants.WorkOrderActionStatus
export const WorkOrderActionStatus = Object.freeze({
    NOT_STARTED: 0,
    IN_PROGRESS: 1,
    DONE: 2,
});

// reports.constants.ReportColumns
export const ReportColumns = Object.freeze({
    FAULTS_DIAMETERS_COLUMNS: 'faults_diameters_columns',
    FAULTS_OPERATORS_COLUMNS: 'faults_operators_columns',
});
